module.exports = __webpack_public_path__ + "static/media/5DPO20.5537efa5.jpg";